export let GlobalVariables = {
	devMode: null,
	isMobile: null,
	resizeCallbacks: [],
	mobileResizeCallbacks: [],
	smoother: null
};
